<div class="log-table" [ngClass]="{ 'side-panel-open': openSidePanel }">
  <div class="log-table-content">
    <div
      class="log-table-content-action-buttons"
      [class.loading]="!(rowData$ | async)?.length"
    >
      <button
        class="log-table-content-action-buttons-reset-button"
        (click)="resetFilters()"
      >
        <img
          src="assets/icons/reset.svg"
          alt="Réinitialiser les filtres"
          style="width: 15px"
        />
        Réinitialiser les filtres
      </button>
      <button
        class="log-table-content-action-buttons-export-button"
        (click)="handleExcelExport()"
      >
        <img
          src="assets/icons/export-excel.svg"
          alt="Exporter en Excel"
          style="width: 15px"
        />
        Export excel
      </button>
    </div>
    <ag-grid-angular
      [columnDefs]="columnDefs"
      [modules]="modules"
      [theme]="theme"
      [rowData]="rowData$ | async"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [domLayout]="'normal'"
      [gridOptions]="gridOptions"
      [localeText]="localeText"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
    >
    </ag-grid-angular>
    <div class="log-table-side-panel">
      <lib-metadata-panel
        *ngIf="currentSidePanel === SidePanel.Metadata"
        [loadingMetadata]="loadingMetadata"
        [metadata]="currentMetadata"
        (closeSidePanel)="closeSidePanel()"
      >
      </lib-metadata-panel>
    </div>
    <div class="loading-container" *ngIf="isLoading$ | async">
      <lib-little-bars-loader></lib-little-bars-loader>
    </div>
  </div>
</div>
